import { render, staticRenderFns } from "./FormPerinnanEsto.vue?vue&type=template&id=9ba78394&scoped=true&"
import script from "./FormPerinnanEsto.vue?vue&type=script&lang=js&"
export * from "./FormPerinnanEsto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba78394",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VForm } from 'vuetify/lib/components/VForm';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDatePicker,VForm,VMenu,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ba78394')) {
      api.createRecord('9ba78394', component.options)
    } else {
      api.reload('9ba78394', component.options)
    }
    module.hot.accept("./FormPerinnanEsto.vue?vue&type=template&id=9ba78394&scoped=true&", function () {
      api.rerender('9ba78394', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormPerinnanEsto.vue"
export default component.exports